
import { Model } from 'backbone';

class ListDetailsModel extends Model {

    initialize() {
    }

    defaults() {
        return {};
    }

    parse(response, options)  {
        return response;
    }
}

export default ListDetailsModel;
